import React, { useEffect } from "react";
import moment from "moment";

const BarComponent = ({ beschikbaarheid, boekingen }) => {

  function datum(cell) {
    if (cell) return moment(cell).format("DD-MM-YYYY");
  }

  return (
    <div className="barback mb-3" style={{padding: '18px'}}>
      {/* Clean single row layout */}
      <div className="row g-3">
        <div className="col-md-3 col-6">
          <div className="info-box bg-primary text-white" style={{minHeight: '85px', padding: '15px', marginBottom: '10px'}}>
            <span className="info-box-icon" style={{width: '55px', height: '55px', fontSize: '24px'}}>
              <i className="fa-solid fa-calendar-days"></i>
            </span>
            <div className="info-box-content">
              <span className="info-box-text" style={{fontSize: '11px', marginBottom: '4px'}}>DATUM</span>
              <span className="info-box-number" style={{fontSize: '20px', fontWeight: '700'}}>{datum(beschikbaarheid.datum)}</span>
            </div>
          </div>
        </div>
        <div className="col-md-3 col-6">
          <div className="info-box bg-info text-white" style={{minHeight: '85px', padding: '15px', marginBottom: '10px'}}>
            <span className="info-box-icon" style={{width: '55px', height: '55px', fontSize: '24px'}}>
              <i className="fa-solid fa-list-check"></i>
            </span>
            <div className="info-box-content">
              <span className="info-box-text" style={{fontSize: '11px', marginBottom: '4px'}}>RESERVERINGEN</span>
              <span className="info-box-number" style={{fontSize: '20px', fontWeight: '700'}}>{beschikbaarheid.aantalreserveringen}</span>
            </div>
          </div>
        </div>
        <div className="col-md-3 col-6">
          <div className="info-box bg-success text-white" style={{minHeight: '85px', padding: '15px', marginBottom: '10px'}}>
            <span className="info-box-icon" style={{width: '55px', height: '55px', fontSize: '24px'}}>
              <i className="fa fa-users"></i>
            </span>
            <div className="info-box-content">
              <span className="info-box-text" style={{fontSize: '11px', marginBottom: '4px'}}>PERSONEN</span>
              <span className="info-box-number" style={{fontSize: '20px', fontWeight: '700'}}>{beschikbaarheid.aantalpersonen}</span>
            </div>
          </div>
        </div>
        <div className="col-md-3 col-6">
          <div className="info-box bg-warning text-dark" style={{minHeight: '85px', padding: '15px', marginBottom: '10px'}}>
            <span className="info-box-icon text-dark" style={{width: '55px', height: '55px', fontSize: '24px'}}>
              <i className="fa-solid fa-user-lock"></i>
            </span>
            <div className="info-box-content">
              <span className="info-box-text" style={{fontSize: '11px', marginBottom: '4px'}}>MAX/MIN</span>
              <span className="info-box-number" style={{fontSize: '20px', fontWeight: '700'}}>
                {beschikbaarheid?.beschikbaarheid?.personenmax}/{beschikbaarheid?.beschikbaarheid?.personenmin}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BarComponent;
